import { render } from "./Recover_password.vue?vue&type=template&id=34f7806f"
import script from "./Recover_password.vue?vue&type=script&lang=js"
export * from "./Recover_password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__